module.exports = __webpack_public_path__ + "img/over_jou.36424e5b.jpg";